var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-outer" }, [
    _c("div", { staticClass: "login-inner" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("resetpwd.TITLE")))]),
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("label", { attrs: { for: "name" } }, [
            _vm._v(_vm._s(_vm.$t("resetpwd.FIELD_EMAIL"))),
          ]),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.email,
                  expression: "formData.email",
                },
              ],
              staticClass: "loginField",
              attrs: {
                id: "email",
                type: "email",
                required: "",
                autofocus: "",
                autocomplete: "",
                autoCorrect: "off",
                autoCapitalize: "none",
              },
              domProps: { value: _vm.formData.email },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.formData, "email", $event.target.value)
                },
              },
            }),
          ]),
          _c("div", [
            _c("p"),
            _c("p", { staticClass: "button-line" }, [
              _c("button", { attrs: { type: "submit" } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("resetpwd.BUTTON_SEND")) +
                    "\n          "
                ),
              ]),
              _vm._v("\n           \n          "),
              _c("button", { on: { click: _vm.goback } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("resetpwd.BUTTON_DISMISS")) +
                    "\n          "
                ),
              ]),
            ]),
          ]),
          _c("div", [
            _vm.errors.length
              ? _c("p", [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("resetpwd.CHANGE_ERRORS_TEXT"))),
                  ]),
                ])
              : _vm._e(),
            _c(
              "ul",
              { staticClass: "errors" },
              _vm._l(_vm.errors, function (error) {
                return _c("li", { key: error }, [
                  _vm._v("\n            " + _vm._s(error) + "\n          "),
                ])
              }),
              0
            ),
          ]),
          _vm.errorMsg
            ? _c("div", [
                _vm._v("\n        " + _vm._s(_vm.errorMsg) + "\n      "),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }